// The IC Memo tab runs on Proxy's one Supabase client - no second client, no
// second set of keys. Same exports the memo app's lib/supabase had.
export { supabase } from '../../../supabase'

// True when a query failed only because the table doesn't exist yet (migration
// not applied), so a panel can show an empty state instead of a raw error.
export const isMissingTable = (e) =>
  !!e && (e.code === '42P01' || /does not exist|schema cache|find the table/i.test(e.message || ''))
